/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { Radio } from 'antd'
import { RADIO_GROUP_CLASS, TypeProps } from '../OutcomeBlockNew'
import * as _ from 'lodash'

/**
 * 아웃컴 이름이 공통으로 사용되지 않는 마켓에 주로 사용 (전반전/풀타임 결과)
 * 행의 컬럼수는 3개, 이름 및 배당이 같이 표시 된다.
 * 아웃컴 개수가 6개 이상인 마켓들이 사용한다. (ex. 홈/홈 2.75, 원정/홈 2.80, 무/원정 6.45)
 * 테이블 상단 컬럼: 없음
 * 테이블 좌측 컬럼: 없음
 *
 * @param {TypeProps} props
 */
const Type6: React.FC<TypeProps> = (props: TypeProps) => {

  const {
    markets,
    initialOutcomeCount,
    makeOutcomesElement,
    selectedField,
  } = props

  const renderOutcomes = (market) => {
    // variant outcome 대응
    let maxCount = initialOutcomeCount
    if (initialOutcomeCount === 0 && market.outcomes.length > 0) {
      maxCount = market.outcomes.length
    }

    const outcomes = []

    if (_.has(market.specifiers, 'variant')) {
      for (let i = 0; i < maxCount; i += 1) {
        const outcome = market.outcomes[i]
        outcomes.push(outcome)
      }
    } else {
      for (let i = 1; i <= maxCount; i += 1) {
        const outcome = market.outcomes.find(object => object.order === i)
        outcomes.push(outcome)
      }
    }

    const outcomeElements = makeOutcomesElement(market, outcomes, true)
    return outcomeElements
  }

  return (
    <Fragment>
      <div className="outcome-btn-wrap">
        <Radio.Group value={selectedField} className={RADIO_GROUP_CLASS.BTN_3_WAY}>
          {markets.map(market => (
            renderOutcomes(market)
          ))}
        </Radio.Group>
      </div>
    </Fragment>
  )
}

export default observer(Type6)
